<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
// import DatePicker from "vue2-datepicker";
import axios from "axios";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import moment from "moment";
// import Vuetable from "vuetable-2";
// import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Loader from "@/components/widgets/loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import MaskedInput from "vue-text-mask";
import Vue from "vue";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
Vue.component("v-select", vSelect);
// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.use(Toasted);
/**
 * new orden component
 */
export default {
  page: {
    title: "Nueva Asignacion",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    // Vuetable,
    // VuetablePagination,
    // DatePicker,
    Loader,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // "masked-input": MaskedInput,
  },
  data() {
    return {
      estados_animal : [
        {
          id: 1,
          nombre: 'Vivo',
          estado: 'Vivo',
        },
        {
          id: 2,
          nombre: 'Muerto',
          estado: 'Muerto',
        },
        {
          id: 3,
          nombre: 'Momia',
          estado: 'Momia',
        },
      ],
      razasDeCerdos : [
        { nombre: "Duroc" },
      { nombre: "Tri-Linea" },
    { nombre: "Landrace" },
    { nombre: "Pietrain" },
    { nombre: "Hampshire" },
    { nombre: "Chester White" },
    { nombre: "TN60" },
    { nombre: "TN70" },
      ],
      idlote:    this.$route.params.idlote,
      idcerdo:    this.$route.params.idcerdo,
      arrayLotes:[],
      arrayLote:[],
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      apiBase:
        process.env.VUE_APP_URL +  "lote_animal/findByIdLoteAnimalActives",
      saldo: 0,
      // Variables para metodos de pago
      cantidad_efectivo: "",
   
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      fecha_traslado : '',
      fecha_posible_parto:'',
      // variables para detalle
      cabezera: [
        
      { key: 'index', label: 'Índice' },
        { key: "codigo", label: "Codigo", thClass: "cell1" },
        { key: "raza", label: "Raza", thClass: "cell1" },
        { key: "peso_ingreso", label: "Peso ingreso", thClass: "cell1" },
        { key: "precio_venta", label: "Precio Venta", thClass: "cell1" },
        { key: "estado_animal", label: "Estado Animal", thClass: "cell1" },
        { key: "causa_muerte", label: "Causa de muerte", thClass: "cell1" },
      ],
      apiUrl: process.env.VUE_APP_URL,
      precio_venta: 0,
      fields: [
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
        {
          name: "codigo",
          title: "Código",
          sortField: "codigo",
          width: "20%",
        },
        {
          name: "raza",
          title: "Raza",
          sortField: "raza",
          width: "20%",
        },
        {
          name: "peso_ingreso",
          title: "Peso Ingreso",
          sortField: "peso_ingreso",
          width: "20%",
        },
        {
          name: "estado_animal",
          title: "Estado Animal",
          sortField: "estado_animal",
          width: "20%",
        },
        {
          name: "causa_muerte",
          title: "Causa muerte",
          sortField: "causa_muerte",
          width: "20%",
        },
      ],
      formPro: {
        fecha_limite: new Date(),
        loteid: -1,
        metodo_pago: "0",
        loteidrecibe : -1,
        lote_recibe : null,
        factura: "",
        fecha_compra: new Date(),
        fecha_entrega: new Date(),
        tiendaid: "",
        tienda: "",
        orden: "",
        lote: "",
        total: "",
        state: true,
        observaciones : "",
        id: 0,
      },
      data: [
        {
          nombre: "",
          cantidad: "",
          precio_compra: "",
          precio_venta: "",
          subtotal: "",
          ubicacion: "",
          sub_presentacion: "",
          button: true,
        },
      ],
      title: "Nueva Inseminación",
      items: [
        {
          text: "Corrales",
          href: "/",
        },
        {
          text: "Corrales",
          active: true,
        },
      ],
      searchType: [
        { nombre: "Codigo", value: "codigo" },
        // { nombre: "Codigo", value: "codigo" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      mask_quetzal: createNumberMask({
        prefix: "Q ",
        suffix: "",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Codigo", value: "producto" },
      filterLabel: { nombre: "Codigo", value: "producto" },
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      newCode: "",
      arrayDetalle: [],
      LotesExist:'',
      totalAnimalesActuales: 0,
      arrayLotesRecibe:[],
      arrayAnimalSalida:[],
      cantidad_animales: 0,
      generatedCodes : new Set(),
    };
  },
  validations: {
    formPro: {
      lote: { required },
      lote_recibe: { required },
      factura: { required },
      fecha_entrega: { required },
      fecha_compra: { required },
      fecha_limite: { required },
      tienda: { required },
      orden: { required },
      total: { required },
    },
    precio_venta: {required},
    cantidad_animales: { required },
    arrayDetalle: {
      required,
      $each: {
        peso_ingreso: {
          required,
        },
      },
    },
    data: { required },

  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal: function () {
              const totales = this.arrayDetalle.reduce(
            (acumulador, animal) => {
           
              if (animal.estado_animal === 'Vivo') {
                acumulador.totalVivos += 1;
                acumulador.totalAnimales += 1;
              } else if (animal.estado_animal === 'Muerto' || animal.estado_animal === 'Momia') {
                acumulador.totalMuertos += 1;
                acumulador.estado = 0;
              }
              acumulador.pesoTotal += parseFloat(animal.peso_ingreso);
              return acumulador;
            },
            {
              totalAnimales: 0,
              totalVivos: 0,
              totalMuertos: 0,
              pesoTotal: 0,
            }
          );

          // Calcular el peso promedio
          totales.pesoPromedio = parseInt(totales.totalAnimales) > 0 ? parseFloat (totales.pesoTotal) / parseFloat(totales.totalAnimales) : 0;

          return totales;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // PROVEEDORES
    eliminarDetalle(index) {
      this.arrayDetalle.splice(index, 1);
    },
    async getCerdosLoteSalida(id, page, search){
        try{
            let url =  process.env.VUE_APP_URL + 'lote_animal/findByIdLoteAnimalActives';
            var response = await axios.get(url,{
                headers: { "x-token": this.userT.token },
                params: {
                    page:page,
                    limite: this.perPage,
                    search: search,
                    id: id
                }
            });
            this.onPaginationData(response.data);
            this.$refs.vuetable.refresh();  

        }catch(e){
            console.log(e);
        }
    },

    async getDatosLotes(val1){
        let me = this;
        me.loading = true;
        if (val1 == null || val1 == ''){
            me.formPro.lote = '';
            me.formPro.loteid = -1;
        }
        else {
            me.formPro.loteid = val1.id;
            await this.getCerdosLoteSalida(val1.id, this.page, this.search);
                 
            // console.log(    val1);
        }
    },
    selectLote(search, loading){
                let me = this;
                loading(true);
                let url =  process.env.VUE_APP_URL + '/lotes/select_lote?filtro=' + search;
                axios.get(url,{
                    headers: { "x-token": this.userT.token },
                }).then(function (response) {
                    // console.log(response);
                    me.arrayLotes = response.data.data.data;
                    loading(false);
                })
                .catch(function (error) {
                    console.log({error});
                });
    },
    getDatosLotesRecibe(val1){
        let me = this;
        me.loading = true;
        if (val1 == null || val1 == ''){
            me.formPro.lote_recibe = '';
            me.formPro.loteidrecibe = -1;
        }
        else {
            me.formPro.loteidrecibe = val1.id;
            // me.totalAnimalesActuales = val1.no_animales;
            // console.log(    val1);
        }
    },
    selectLoteRecibe(search, loading){
                let me = this;
                loading(true);
                let url =  process.env.VUE_APP_URL + '/lotes/select_lote?filtro=' + search + '&tipo_lote=' + "Gestacion";
                axios.get(url,{
                    headers: { "x-token": this.userT.token },
                }).then(function (response) {
                    // console.log(response);
                    me.arrayLotesRecibe = response.data.data.data;
                    loading(false);
                })
                .catch(function (error) {
                    console.log({error});
                });
    },
    tomandototal() {
      let temp = 0;
      temp = parseFloat(this.calcularTotal);
      this.formPro.total = temp;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    validarPesoIngreso() {
      return this.arrayDetalle.every((detalle) => detalle.peso_ingreso !== null && detalle.peso_ingreso !== '' && detalle.peso_ingreso > 0);
    },
    //Validaciones antes de guardar
    validaciones() {
      // stop here if form is invalid
      this.$v.$touch();
      // console.log(this.formPro.proveedor);
    //   console.log(this.formPro.loteid);
      if (
        this.calcularTotal.totalVivos <=0 ||  this.calcularTotal.pesoTotal <=0 || this.calcularTotal.pesoPromedio <=0
      ) {
        // console.log("retroll");
        Vue.toasted.error("Ingresa los pesos de los animales ", this.options);
        return;
      } 
      else if(this.arrayDetalle.length <=0){
        Vue.toasted.error("Agregue los animales nacidos ", this.options);
        return;
      }
      else if (!this.validarPesoIngreso()) {
        Vue.toasted.error('Todos los pesos de ingreso deben estar llenos.',this.options);
        return;
      }
      
      else {
  
          this.save();
        }
      
    },
    //Guardar registro
    async save() {
      this.showModalL = true;
      axios
        .post(
          process.env.VUE_APP_URL + "partos/store",
          {
            cantidad_vivos: this.calcularTotal.totalVivos,
            cantidad_muertos : this.calcularTotal.totalMuertos,
            total_animales: this.calcularTotal.totalAnimales + 1,
            peso_promedio : this.calcularTotal.pesoPromedio.toFixed(2),
            total_peso : this.calcularTotal.pesoTotal,
            detalle: this.arrayDetalle,
            cerdoId : this.idcerdo,
            lote: this.idlote,
            userId:this.userT.id,
          },
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then(() => {
          Vue.toasted.success("Registro Guardado", this.options);
          this.showModalN = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
          this.$router.push({
            name: 'vista_lote',
            params: { id: this.idlote },
            shallow: true,
          });
        });
    },
    // Funciones para trabajar con detalles

    converMaskToNumberxd(number) {
      var myNumber = "";
      for (var i = 0; i < number.length; i += 1) {
        if (
          number.charAt(i) === "Q" ||
          number.charAt(i) === "€" ||
          number.charAt(i) === "$" ||
          number.charAt(i) === "%" ||
          number.charAt(i) === "," ||
          number.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += number.charAt(i);
        }
      }
      return parseFloat(myNumber).toFixed(2);
    },
    // Funciones para formatos
   
    formatQuetzales(amount) {
      let num = parseFloat(amount),
        formatted;
      formatted = num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      return (amount = "Q " + formatted);
    },
  
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    generateUniqueCode(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let code = '';

      do {
        code = '';
        for (let i = 0; i < length; i++) {
          const randomIndex = Math.floor(Math.random() * characters.length);
          code += characters[randomIndex];
        }
      } while (this.generatedCodes.has(code)); // Verifica si el código ya ha sido generado

      // Almacena el código generado para asegurar que sea único
      this.generatedCodes.add(code);

      return code;
    },
    generateUniqueId() {
    // Obtenemos el número de milisegundos desde el 1 de enero de 1970
      const timestamp = Date.now();

      // Puedes añadir un componente adicional si deseas asegurarte de que es único incluso en casos extremos
      // Por ejemplo, podrías concatenar un valor aleatorio o un índice
      const randomComponent = Math.floor(Math.random() * 1000); // Componente adicional opcional

      // Generamos el ID único
      const uniqueId = `${timestamp}-${randomComponent}`;

      return uniqueId;
    },
    agregarDetalle(cantidad) {

      const me = this;
      const precio_venta = this.precio_venta;
            for(let i = 0; i < cantidad; i++){
              me.arrayDetalle.push({
                codigo : this.generateUniqueCode(5),
                raza: me.razasDeCerdos[Math.floor(Math.random() * me.razasDeCerdos.length)].nombre,
                semanas : 0,
                sexo : '',
                peso_ingreso : 0,
                precio_compra : 0,
                estado : 1,
                estado_animal : 'Vivo',
                precio_venta,
                causa_muerte:'',
                tipoAnimalId : 2,
                partos : 0,
                fecha_ingreso :this.customFormatter(new Date()), 
              });
            }
            
          
    },
    verificaAnimal(stock) {
      const me = this;
    //   console.log(stock)
      if (me.encuentra(stock.cerdo.id)) {
        return true;
      }
    },
    sumarDias(dias) {
    // Crear una nueva instancia de la fecha para evitar modificar el original
    let nuevaFecha = new Date();
    // Sumar los días
    nuevaFecha.setDate(nuevaFecha.getDate() + dias);
    return nuevaFecha;
    },
    // Esta función encuentra si en el detatalle ya esta la habitacion
    encuentra(id) {
      let sw = 0;
      for (var i = 0; i < this.arrayDetalle.length; i++) {
        if (this.arrayDetalle[i].id == id) {
          sw = true;
        }
      }
      return sw;
    },


    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
    //   console.log(this.items);
      this.$refs.pagination.setPaginationData(paginationData);
    //   this.$refs.vuetable.refresh();  
    //   console.log(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    async changePageSize() {
        // await this.getCerdosLoteSalida(this.formPro.loteid, this.page, this.search);
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            id : this.formPro.loteid
          }
        : {
            criterio: sortOrder[0]
              ? sortOrder[0].sortField
              : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            id : this.formPro.loteid
          };
    },
  },
};
</script>

<template>
  <Layout>
    <b-modal
      centered
      v-model="showModalL"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
      no-close-on-backdrop
      content-class="my-class"
      header-class="my-class"
    >
      <template #modal-header="{}">
        <!-- Emulate built in modal header close button action -->

        <h5></h5>
      </template>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <fulfilling-bouncing-circle-spinner
                :animation-duration="2000"
                :size="90"
                color="#2a3042"
              />
            </div>
          </div>
        </div>
      </form>
    </b-modal>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="pt-3">
              <div class="row">
                <div class="col-">
                  <div class="row">
                    <div class="col">
                      <h4>Datos Generales</h4>
                    </div>

                    <div class="col" align="right">
                      <div>
                        <router-link
                          :to="{
                            name: 'vista_lote',
                            params: { id: idlote },
                          }"
                        >
                          <b-button
                            variant="outline-primary"
                            type="button"
                            class="btn btn-rounded mb-2 me-2"
                          >
                            <i class="mdi mdi-arrow-collapse-left"></i> Regresar
                          </b-button>
                        </router-link>
                      </div>
                    </div>
                  </div>

                  <div class="text-center">
                    <div class="row justify-content-center align-items-center">
                      <div class="col-sm-6 col-md-4">
                        <p class="text-muted mb-2">Cantidad Animales Que Nacieron</p>
                        <input
                          id="name"
                          v-model="$v.cantidad_animales.$model"
                          type="number"
                          class="form-control mb-2"
                          placeholder="Ingrese los costos de inseminación"
                          :class="{
                            'is-invalid': $v.cantidad_animales.$error,
                          }"
                          @input="$v.cantidad_animales.$touch()"
                        />

                        <div
                          v-if="
                            $v.cantidad_animales.$error &&
                            !$v.cantidad_animales.required
                          "
                          class="invalid-feedback"
                        >
                          La cantidad de animales es obligatoria.
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <p class="text-muted mb-2">Precio Venta</p>
                        <input
                          id="name"
                          v-model="$v.precio_venta.$model"
                          type="number"
                          class="form-control mb-2"
                          placeholder="Ingrese los costos de inseminación"
                          :class="{
                            'is-invalid': $v.precio_venta.$error,
                          }"
                          @input="$v.precio_venta.$touch()"
                        />

                        <div
                          v-if="
                            $v.precio_venta.$error &&
                            !$v.precio_venta.required
                          "
                          class="invalid-feedback"
                        >
                          El precio de venta es obligaroio
                        </div>
                      </div>
                      
                      <div class="col-auto">
                        <b-button
                          variant="outline-danger"
                          type="button"
                          class="btn btn-rounded"
                          @click="agregarDetalle(cantidad_animales)"
                        >
                          <i class="mdi mdi-arrow-collapse-left"></i> Procesar
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <template>
  <div class="text-center">
    <!-- Sección donde se muestran los totales -->
    <div class="row justify-content-center mt-4">
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
        <div class="card bg-light shadow-sm">
          <div class="card-body text-center">
            <h5 class="font-weight-bold text-primary">Total de Animales</h5>
            <p class="h3">{{ calcularTotal.totalAnimales }}</p>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
        <div class="card bg-light shadow-sm">
          <div class="card-body text-center">
            <h5 class="font-weight-bold text-success">Total Vivos</h5>
            <p class="h3">{{ calcularTotal.totalVivos }}</p>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-3">
        <div class="card bg-light shadow-sm">
          <div class="card-body text-center">
            <h5 class="font-weight-bold text-danger">Total Muertos</h5>
            <p class="h3">{{ calcularTotal.totalMuertos }}</p>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3">
        <div class="card bg-light shadow-sm">
          <div class="card-body text-center">
            <h5 class="font-weight-bold text-info">Peso Total</h5>
            <p class="h3">{{ calcularTotal.pesoTotal }} Lb</p>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-3">
        <div class="card bg-light shadow-sm">
          <div class="card-body text-center">
            <h5 class="font-weight-bold text-warning">Peso Promedio</h5>
            <p class="h3">{{ calcularTotal.pesoPromedio.toFixed(2) }} Lb</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <Loader :loading="loadingtable">
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="p-3 text-muted"
      >
     
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <h5><i class="bx bxs-food-menu"></i></h5>
            </span>
            <h5>
              <span class="d-none d-sm-inline-block">
                <i class="bx bxs-food-menu"></i>Asignar detalles</span
              >
            </h5>
          </template>

          <b-table
          small
          striped
            responsive
            v-if="arrayDetalle.length > 0"
            ref="table"
            :items="arrayDetalle"
            :fields="cabezera"
          >
          <template #cell(index)="data">
              
              <b-button-group>
                <b-button
                    size="md"
                    variant="outline-danger"
                    @click="eliminarDetalle(data.index)"
                ><i :class="'bx bx-trash'"
                /></b-button>
              </b-button-group>
            </template>
            <template #cell(codigo)="data">
              <input
                id="name"
                v-model="data.item.codigo"
                type="text"
                class="form-control mb-2"
                placeholder="Ingrese el peso de nacimiento"

                />
            </template>
            <template #cell(raza)="data">
              <select v-model="data.item.raza" class="form-control">
                  <option v-for="(raza, index) in razasDeCerdos" :key="index" :value="raza.nombre">
                    {{ raza.nombre }}
                  </option>
                </select>
            </template>
            <template #cell(peso_ingreso)="data">
              <!-- {{ data.item.fecha_ingreso }} -->
                <input
                id="name"
                v-model="data.item.peso_ingreso"
                type="number"
                class="form-control mb-2"
                placeholder="Ingrese el peso de nacimiento"

                />
            </template>
            <template #cell(precio_venta)="data">
              <!-- {{ data.item.fecha_ingreso }} -->
                <input
                id="name"
                v-model="data.item.precio_venta"
                type="number"
                class="form-control mb-2"
                placeholder="Ingrese el peso de nacimiento"

                />
            </template>
            <template #cell(causa_muerte)="data">
              <!-- {{ data.item.fecha_ingreso }} -->
                <input
                id="name"
                v-model="data.item.causa_muerte"
                type="text"
                class="form-control mb-2"
                placeholder="Ingrese la causa de muerte"

                />
            </template>
            <template #cell(estado_animal)="data">
            <select v-model="data.item.estado_animal" class="form-control">
              <option v-for="estado in estados_animal" :key="estado.id" :value="estado.estado">
                {{ estado.nombre }}
              </option>
            </select>
          </template>
          </b-table>
        </b-tab>
      </b-tabs>

      <div class="col-sm-12 pt-3">
        <div class="row">
          <div class="col">
            <router-link
              class="d-grid gap-2"
              :to="{
                            name: 'vista_lote',
                            params: { id: idlote },
                          }"
            >
              <b-button
                block
                size="lg"
                variant="outline-primary"
                type="button"
                class="btn btn-rounded mb-2 me-2"
              >
                <i class="bx bx-arrow-back"></i>&nbsp;&nbsp;<b>REGRESAR</b>
              </b-button>
            </router-link>
          </div>
          <div class="col d-grid gap-2">
            <b-button
              block
              size="lg"
              variant="outline-success"
              class="btn btn-rounded mb-2 me-2"
              @click="validaciones('save')"
            >
              {{ tomandototal() }}
              <i class="mdi mdi-truck-fast me-1"></i>
              &nbsp;&nbsp;<b>GUARDAR</b>
            </b-button>
          </div>
        </div>
      </div>
    </Loader>
    <!-- end row -->
  </Layout>
</template>
